import React, { Component } from 'react'
import {sessionService} from 'redux-react-session';

export default class SearchForm extends Component {

  handleSearchChange (e) {
    var searchInput = e.target.value
    sessionService.loadSession().then(session => {
      session.searchInput = searchInput;
      sessionService.saveSession(session).then(() => {
        this.handleSubmit();
      });
    });
  }

  handleStatusChange (e) {
    var status = e.target.value
    sessionService.loadSession().then(session => {
      session.status = status;
      sessionService.saveSession(session).then(() => {
        this.handleSubmit();
      });
    });
  }

  handleSubmit () {
    //e.preventDefault(); // produced a warning (synthetic event, preventDefault no-op)
    //this.props.searchCards(self.searchInput);
    var companyId = this.props.user.isAdmin ? '' : this.props.user.companyId;
    //this.props.getCards(companyId, self.searchInput, self.status);
    this.props.getCards(companyId);
  }

  render() {
      const translations = this.props.translations;

      return <div className='pb-3'>
        <form className='row' onSubmit={::this.handleSubmit}>
          <div className='col-12 col-md-8'>
              <label  className='upper-label'>{translations['search.Etsi hakemuksia']}</label>
              <input type='text' className='form-control w-100' id='inputSearch'
                     placeholder={translations['search.Etsi yrityksen tai henkilön perusteella']}
                     onChange={::this.handleSearchChange} />
          </div>
          <div className='col-12 col-md-4'>
            <label  className='upper-label'>{translations['search.Tila']}</label>
            <select className='form-control full-width'
                    onChange={::this.handleStatusChange}>
              <option value=''>{translations['search.Kaikki']}</option>
              <option value='STATUS_PENDING'>{translations['cardStatus.Odottaa käsittelyä']}</option>
              <option value='STATUS_APPROVED'>{translations['cardStatus.Hyväksytty']}</option>
              <option value='STATUS_DECLINED'>{translations['cardStatus.Hylätty']}</option>
              <option value='STATUS_RETURNED'>{translations['cardStatus.Palautettu']}</option>
            </select>
          </div>
          {/*<button className='btn btn-primary' disabled={this.props.fetching}>Search</button>*/}
        </form>
      </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchForm.js